import { Component } from "react"
import PropTypes from "prop-types"
import { Card } from "@mui/material"
import OptimizationSettings from "modules/optimization-settings"
import OptimizationScanner from "modules/optimization-scanner"
import OptimizationScorecard from "modules/optimization-scorecard"
import OptimizationTrades from "modules/optimization-trades"
import DateSelector from "components/date-picker"
import SaveExperiment from "modules/save-experiment"
import { API_CONSTRAINTS } from "./shapes"
import "./style.scss"
import withNavigate from "hocs/withNavigate"

class Optimization extends Component {
  static propTypes = {
    earliestDate: PropTypes.string.isRequired,
    selectedDate: PropTypes.string.isRequired,
    latestDate: PropTypes.string.isRequired,
    apiConstraints: API_CONSTRAINTS.isRequired,
    currentConstraints: PropTypes.object.isRequired,
    tradesPanelOpen: PropTypes.bool.isRequired,
    setRiskTarget: PropTypes.func.isRequired,
    setConstraints: PropTypes.func.isRequired,
    toggleTradesPanel: PropTypes.func.isRequired,
    portfolioData: PropTypes.object,
    removeFactor: PropTypes.func.isRequired,
    loadTrades: PropTypes.func.isRequired,
    rebalanceUrl: PropTypes.string.isRequired,
    setOptimizationDate: PropTypes.func.isRequired,
    setExperimentSelectedDate: PropTypes.func.isRequired,
    resetSettings: PropTypes.func.isRequired,
    setSettings: PropTypes.func.isRequired,
    portfolioType: PropTypes.string.isRequired,
    unmodeledDates: PropTypes.objectOf(PropTypes.bool).isRequired,
    modelId: PropTypes.string.isRequired,
    account: PropTypes.string.isRequired,
    portfolioId: PropTypes.string.isRequired,
    riskTarget: PropTypes.object.isRequired,
    experiment: PropTypes.object,
    openDialog: PropTypes.func.isRequired,
    rebalanceTrades: PropTypes.array.isRequired,
    trades: PropTypes.array.isRequired,
    allPositions: PropTypes.array.isRequired,
    portfolioNetLong: PropTypes.number.isRequired,
    setConstraint: PropTypes.func.isRequired,
    setSetting: PropTypes.func.isRequired,
    activatedConstraints: PropTypes.object.isRequired,
    setFactors: PropTypes.func.isRequired,
    removeActivatedFactor: PropTypes.func.isRequired,
    selectedExperiment: PropTypes.object,
    experimentSecuritiesConstraints: PropTypes.object,
    loadSecuritiesConstraints: PropTypes.func.isRequired,
    loadTradesConstraints: PropTypes.func.isRequired,
    isOpPro: PropTypes.bool.isRequired,
    navigate: PropTypes.func.isRequired,
    portfolioUUID: PropTypes.string.isRequired,
  }

  componentDidMount() {
    const { selectedExperiment, loadSecuritiesConstraints, loadTradesConstraints, experimentSecuritiesConstraints } = this.props

    if (selectedExperiment) {
      if (experimentSecuritiesConstraints) {
        loadSecuritiesConstraints(experimentSecuritiesConstraints)
      }
      loadTradesConstraints(experimentSecuritiesConstraints)
    }
  }

  loadRebalance = rebalance => {
    const { loadTrades, navigate, rebalanceUrl } = this.props
    loadTrades(rebalance, null)
    navigate(rebalanceUrl)
  }

  toggleSaveExperiment = () => {
    const { openDialog, experiment, selectedDate, latestDate, portfolioUUID, portfolioId } = this.props
    openDialog({
      title: "Save Experiment",
      content: <SaveExperiment experiment={experiment} isOneDayExperiment={selectedDate === latestDate} portfolioId={portfolioUUID} portfolioAlias={portfolioId} />,
    })
  }

  render() {
    const {
      earliestDate,
      latestDate,
      selectedDate,
      apiConstraints,
      currentConstraints,
      tradesPanelOpen,
      setRiskTarget,
      setConstraints,
      toggleTradesPanel,
      removeFactor,
      portfolioData,
      setOptimizationDate,
      unmodeledDates,
      resetSettings,
      setSettings,
      portfolioType,
      riskTarget,
      rebalanceTrades,
      trades,
      allPositions,
      portfolioNetLong,
      setConstraint,
      setSetting,
      activatedConstraints,
      setFactors,
      removeActivatedFactor,
      selectedExperiment,
      setExperimentSelectedDate,
      isOpPro,
    } = this.props

    return <div className="modules_optimization">
        <Card className="card">
          <div className="material-card-header">
            Efficient Frontier
          </div>
          <div className="material-card-subheader">
            <DateSelector {...{ earliestDate, latestDate, selectedDate, exclusionMap: unmodeledDates, onChange: selectedExperiment ? setExperimentSelectedDate : setOptimizationDate }} />
          </div>
          <OptimizationSettings
            activatedConstraints={activatedConstraints}
            setSetting={setSetting}
            setConstraint={setConstraint}
            setFactors={setFactors}
            removeActivatedFactor={removeActivatedFactor}
            portfolioType={portfolioType}
            resetSettings={resetSettings}
            applyConstraints={setConstraints}
            applySettings={setSettings}
            constraints={currentConstraints}
            removeCurrentFactor={removeFactor}
            portfolioNetLong={portfolioNetLong}
            portfolioData={portfolioData}
            isOpPro={isOpPro}
          />
          <OptimizationScanner noSpinner setRiskTarget={setRiskTarget} riskTarget={riskTarget} />
        </Card>
        <Card className="card">
          <div className="material-card-header">Optimization Scorecard</div>
          <OptimizationScorecard
            noSpinner
            constraints={apiConstraints}
            portfolioData={portfolioData}
            toggleTradesPanel={toggleTradesPanel}
            riskTarget={riskTarget}
            toggleSaveExperiment={this.toggleSaveExperiment}
            saveVisible={!selectedExperiment}
          />
        </Card>
        <OptimizationTrades
          on={selectedDate}
          loadRebalance={this.loadRebalance}
          open={tradesPanelOpen}
          onClose={toggleTradesPanel}
          applyConstraints={setConstraints}
          currentConstraints={currentConstraints}
          rebalanceTrades={rebalanceTrades}
          trades={trades}
          toggleSaveExperiment={this.toggleSaveExperiment}
          allPositions={allPositions}
          saveVisible={!selectedExperiment}
          simulateVisible={!selectedExperiment}
        />
    </div>
  }
}

export default withNavigate(Optimization)
